import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const session = authService.getActiveSession();
  const isLoginRequest = request.url.endsWith('/auth/login');
  const token = session?.accessToken;
  const requestWithAuth =
    !token || isLoginRequest
      ? request
      : request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'X-User-Role': session?.role ?? 'Clerk',
          },
        });

  return next(requestWithAuth).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !isLoginRequest) {
        authService.invalidateSession();

        void router.navigate(['/login'], {
          queryParams: {
            reason: 'expired',
            returnUrl: router.url,
          },
        });
      }

      return throwError(() => error);
    }),
  );
};
